import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import React from 'react';
import { CompliancePercentageSection } from './CompliancePercentangeSection';
import { ComplianceDetails } from './ComplianceDetails';
import { useSelector } from 'react-redux';
import { selectCredOneDetails } from 'store/redux-store/placement-details/selectors';
import { CredentialingNoPlacementData } from './CredentialingNoPlacementData';

export const CredentialingOneTab = () => {
  const credOneData = useSelector(selectCredOneDetails);
  return (
    <>
      {credOneData ? (
        <LayoutGrid xs={12} style={{ height: '100%' }}>
          <LayoutGridItem
            xs={4}
            sx={theme => ({ backgroundColor: theme.palette.framework.system.whisper })}
          >
            <CompliancePercentageSection />
          </LayoutGridItem>
          <LayoutGridItem xs={8}>
            <ComplianceDetails />
          </LayoutGridItem>
        </LayoutGrid>
      ) : (
        <CredentialingNoPlacementData />
      )}
    </>
  );
};
